export default function getCountriesReducer
    (state = {error: null, success: null, processing: false}, action) {

    switch (action.type) {
        case 'GET_COUNTRIES_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'GET_COUNTRIES_ERROR':
            return {...state, ...{error: action.error}};

        case 'GET_COUNTRIES_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default:
            return state;
    }
}